import { useContext } from "react";
import { formInlineContext } from "../FormInline";
import { twMerge } from "tailwind-merge";

interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  formSelectSize?: "sm" | "lg";
}

function FormSelect(props: FormSelectProps) {
  const formInline = useContext(formInlineContext);
  const { formSelectSize, ...computedProps } = props;
  const isMulti =
    Boolean((computedProps as React.SelectHTMLAttributes<HTMLSelectElement>).multiple) ||
    (typeof (computedProps as React.SelectHTMLAttributes<HTMLSelectElement>).size === "number" &&
      ((computedProps as React.SelectHTMLAttributes<HTMLSelectElement>).size as number) > 1);
  return (
    <select
      {...computedProps}
      className={
        twMerge([
          "disabled:bg-slate-100 disabled:cursor-not-allowed disabled:dark:bg-darkmode-700/50",
          "[&[readonly]]:bg-slate-100 [&[readonly]]:cursor-not-allowed [&[readonly]]:dark:bg-darkmode-700/50",
          // Single-select: show dropdown chevron background
          !isMulti &&
            "bg-[length:20px_auto] bg-chevron-black transition duration-200 ease-in-out w-full text-sm border-slate-300/60 shadow-sm rounded-md py-2 px-3 pr-8 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40 dark:!bg-darkmode-700 dark:focus:ring-slate-700 dark:focus:ring-opacity-50 dark:bg-chevron-white",
          // Multi-select: no chevron background (prevents repeated icons)
          isMulti &&
            "transition duration-200 ease-in-out w-full text-sm border-slate-300/60 shadow-sm rounded-md py-2 px-3 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40 dark:!bg-darkmode-700 dark:focus:ring-slate-700 dark:focus:ring-opacity-50",
          props.formSelectSize == "sm" && "text-xs py-1.5 pl-2 pr-8",
          props.formSelectSize == "lg" && "text-lg py-1.5 pl-4 pr-8",
          formInline && "flex-1",
          props.className,
        ])
      }
    >
      {props.children}
    </select>
  );
}

export default FormSelect;
